import { useEffect, useState } from "react";
import * as S from "./styles";
import { TournamentResponse } from "../../../../api/tournament";
import TimerPrizeList from "./prize-list";

interface TimerPrizeAndNoticeProps {
  data: TournamentResponse | null;
  visibleRanks: number[];
  subPrizeFont: number;
}

const TimerPrizeAndNotice = ({
  data,
  visibleRanks,
  subPrizeFont,
}: TimerPrizeAndNoticeProps) => {
  const [currentBox, setCurrentBox] = useState<string>("prize");
  const [animClass, setAnimClass] = useState("timer-enter");

  useEffect(() => {
    if (data?.notice && data?.notice !== "") {
      const interval = setInterval(() => {
        setAnimClass("timer-exit");
        const timeout = setTimeout(() => {
          setCurrentBox((prev) => (prev === "prize" ? "notice" : "prize"));
          setAnimClass("timer-enter");
        }, 300);
        return () => clearTimeout(timeout);
      }, 3000);

      return () => clearInterval(interval);
    }
  }, [data]);

  return (
    <S.TimerPrizeAndNoticeWrapper>
      {currentBox === "prize" && (
        <S.TimerPrizeWrapper className={animClass}>
          <div className="title">PRIZE POOL</div>
          <TimerPrizeList
            data={data}
            visibleRanks={visibleRanks}
            subPrizeFont={subPrizeFont}
          />
        </S.TimerPrizeWrapper>
      )}
      {currentBox === "notice" && (
        <S.Timer1NoticeWrapper className={animClass}>
          <div className="title">공지사항</div>
          <div
            className="value"
            dangerouslySetInnerHTML={{
              __html: data?.notice ? data.notice.replace(/\n/g, "<br />") : "",
            }}
          />
        </S.Timer1NoticeWrapper>
      )}
      {currentBox === "prize" && (
        <img src="/image-web/timer/prize-list-logo.svg" alt="logo" />
      )}
    </S.TimerPrizeAndNoticeWrapper>
  );
};

export default TimerPrizeAndNotice;
